import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ testId, size = "sm", label = "VERIFIED" }) {
  const sizeCls = size === "lg" ? "text-xs px-2.5 py-1.5" : "text-[9px] px-2 py-1";
  const icon = size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3";
  return (
    <span
      data-testid={testId}
      title="Verified creator — 3+ paid sales"
      className={`inline-flex items-center gap-1 font-mono uppercase tracking-[0.2em] bg-[#CCFF00] text-black border border-[#CCFF00] ${sizeCls}`}
    >
      <BadgeCheck className={icon} strokeWidth={2.5} />
      {label}
    </span>
  );
}
